export const PathName = window.location.pathname;
